import { FEATURES, MODULES } from '../../constants/template-info'
import { captureException } from '../sentryUtil'

import { CROSS_PLATFORM_EVENT_TYPES } from './constants'

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (payload: string) => void
    }
  }
}

export const emitReactNativeEvent = (action: CROSS_PLATFORM_EVENT_TYPES, payload?: object) => {
  if (!window.ReactNativeWebView) return
  try {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        action,
        payload,
      }),
    )
  } catch (e) {
    captureException(e, {
      module: MODULES.QUINCE_APP,
      feature: FEATURES.EMIT_REACT_NATIVE_EVENT,
      extraInfo: {
        // @i18n-ignore
        message: 'emitReactNativeEvent failed',
      },
    })
  }
}
